import React from "react";
import "./style.scss";

const Text = ({
  align = "left",
  maxWidth = "auto",
  children,
  size = "regular",
}) => {
  return (
    <p
      style={{ maxWidth: maxWidth }}
      className={`ldsrf-text align-${align} size-${size}`}
    >
      {children}
    </p>
  );
};

export default Text;
